import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AuthService } from './auth.service';

@Component({
  selector: 'app-login',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './login.component.html',
  styleUrl: './login.component.css',
})
export class LoginComponent {
  private readonly auth = inject(AuthService);
  private readonly route = inject(ActivatedRoute);

  signingIn = false;
  errorMessage = sessionStorage.getItem('tops.auth.error') || '';

  async signIn(): Promise<void> {
    if (this.signingIn) return;
    this.signingIn = true;
    sessionStorage.removeItem('tops.auth.error');
    this.errorMessage = '';
    await this.auth.login(this.route.snapshot.queryParamMap.get('returnUrl') || '/');
  }
}